const votingLimitOperatorOptions = Object.freeze([
  { text: "et", value: 1 },
  { text: "ou", value: 2 },
]);

const departBuildingLotNewOwnerTypeOptions = Object.freeze([
  { text: "Propriétaire existant de ce bâtiment", value: 1 },
  { text: "Nouveau propriétaire", value: 2 },
]);

const departBuildingLotNewOwnerTypes = Object.freeze({
  existing: 1,
  new: 2,
});

export {
  votingLimitOperatorOptions,
  departBuildingLotNewOwnerTypeOptions,
  departBuildingLotNewOwnerTypes,
};
